import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  CartDefaultProps,
  CartPropTypes,
} from '@/common/proptypes/Cart/Cart.proptypes';
import { CartItemPropTypes } from '@/common/proptypes/Cart/CartItem.proptypes';
import {
  WarehouseDefaultProps,
  WarehousePropTypes,
} from '@/common/proptypes/Common/Warehouse/Warehouse.proptypes';

export const ContentDefaultProps = {
  ...BaseDefaultProps,
  cart: { ...CartDefaultProps },
  currentItems: [],
  isUpdated: false,
  onModifyItem: () => {},
  onRemoveItem: () => {},
  refetchCart: () => {},
  warehouse: { ...WarehouseDefaultProps },
};

export const ContentPropTypes = {
  ...BasePropTypes,
  cart: PropTypes.shape({ ...CartPropTypes }),
  currentItems: PropTypes.arrayOf(PropTypes.shape({ ...CartItemPropTypes })),
  isUpdated: PropTypes.bool,
  onModifyItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
  refetchCart: PropTypes.func,
  warehouse: PropTypes.shape({ ...WarehousePropTypes }),
};
